module.exports = __webpack_public_path__ + "static/media/saibpp.8e8e64de.png";